import React, { useEffect, useRef, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { debounce } from 'lodash-es';
import { catchError } from '../Actions/Error.action';
import { loadError, update } from '../Actions/Cart.action';
import { translate } from '../Services/translation';

const CartItem = ({ item, handleRemoveProduct, setShowError }) => {
  const dispatch = useDispatch();

  const [errorMessage, setErrorMessage] = useState('');

  const [cartQuantity, setCartQuantity] = useState(item.quantity);

  const mapCartToAbort = useRef({});

  const cart = useSelector((state) => state.cart);

  useEffect(() => {
    const quantity = cart.orderRows.find(x => x.rowSystemId === item.rowSystemId)?.quantity;

    if(quantity !== cartQuantity){
      setCartQuantity(quantity)
    }
  }, [cart]);
  const updateCart = useRef(
    debounce((rowSystemId, quantity) => {
      mapCartToAbort.current[rowSystemId] = new AbortController();
      dispatch(
        update(rowSystemId, quantity, mapCartToAbort.current[rowSystemId])
      ).catch((ex) => {
        setShowError(true);
        dispatch(catchError(ex, (error) => loadError(error)));
      });
    }, 500)
  ).current; // Access the debounced function from the useRef hook

  function isAvailableInStock(newTotal) {
    return newTotal <= item.maxQuantity;
    let rows = cart.orderRows.filter((x) => x.rowSys === item.rowSys);

    if (rows === 0) {
      return newTotal <= item.maxQuantity;
    }

    let amount = rows.reduce((sum, x) => sum + x.quantity, 0);

    return amount + newTotal <= item.maxQuantity;
  }

  function updateCartItem(newTotal) {
    setErrorMessage('');

    updateCart(item.rowSystemId, newTotal);

    // Clean up function to cancel any pending requests
    return () => {
      Object.values(mapCartToAbort.current).forEach((controller) => {
        controller.abort();
      });
    };
  }

  function decrement() {
    let newTotal = cartQuantity - item.minQuantity;

    if (newTotal > 0) {
      setCartQuantity(newTotal);

      return updateCartItem(newTotal);
    }

    setErrorMessage(translate('cart.item.quantity.minquantity'));
  }

  function increment() {
    let newTotal = cartQuantity + item.minQuantity;

    if (item.isOrderItem) {
      setCartQuantity(newTotal);
      return updateCartItem(newTotal);
    }
    if (isAvailableInStock(newTotal)) {
      setCartQuantity(newTotal);

      return updateCartItem(newTotal);
    }

    setErrorMessage(translate('cart.item.quantity.notenoughinstock'));
  }

  return (
    <div className="cart__content__item">
      <img
        className="cart__content__item__product-image"
        src={item.image}
        alt={item.name}
      />
      <div className="cart__content__item__product-info">
        <div className="cart__content__item__product-info__item">
          <div className="cart__content__item__product-info__item__info">
            <p className="cart__content__item__product-info__item__info__title">
              {item.name}
            </p>
            {item.information.map((x, index) => {
              return (
                <p className="checkout__article-information" key={index}>
                  {x}
                </p>
              );
            })}
          </div>
          {item.campaignPrice ? (
            <div>
              <p className="cart__content__item__product-info__item__price--old">
                {item.totalPrice}
              </p>
              <p className="cart__content__item__product-info__item__price--discount">
                {item.totalCampaignPrice}
              </p>
            </div>
          ) : (
            <p className="cart__content__item__product-info__item__price">
              {item.totalPrice}
            </p>
          )}
        </div>
        <div className="cart__content__item__product-info__item">
          <div className="cart__content__item__product-info__item__counter">
            <button
              type="button"
              id="itemcounter-remove"
              onClick={() => decrement()}
            >
              -
            </button>
            <div id="itemcounter-current">{cartQuantity}</div>
            <button
              type="button"
              id="itemcounter-add"
              onClick={() => increment()}
            >
              +
            </button>
          </div>
          <a
            className="cart__content__item__product-info__item__link"
            onClick={() => handleRemoveProduct(item)}
            target="_blank"
            rel="noreferrer"
          >
            {translate('minicart.delete')}
          </a>
        </div>
        {errorMessage && (
          <span className="cart__content__item__error-message">
            {errorMessage}
          </span>
        )}
      </div>
    </div>
  );
};

export default CartItem;
